import type { SalesOrdersTranslations } from './types';

/**
 * Urdu translations for SalesOrders domain
 * Comprehensive translations covering all UI text
 */
export const urTranslations: SalesOrdersTranslations = {
  // Page/Section level
  title: 'سیلز آرڈرز',
  subtitle: 'سیلز آرڈرز اور معاہدوں کا انتظام کریں',
  overview: 'جائزہ',

  // Actions
  addSalesOrder: 'سیلز آرڈر شامل کریں',
  editSalesOrder: 'سیلز آرڈر میں ترمیم کریں',
  deleteSalesOrder: 'سیلز آرڈر حذف کریں',
  createSalesOrder: 'سیلز آرڈر بنائیں',
  customer: 'کسٹمر',
  selectCustomerToCreate: 'سیلز آرڈر بنانے سے پہلے ہیڈر سے کسٹمر منتخب کریں۔',
  readOnlyAccess: 'آپ کے کردار کو سیلز آرڈرز تک صرف دیکھنے کی رسائی ہے۔',
  newSalesOrder: 'نیا سیلز آرڈر',
  reorder: 'دوبارہ آرڈر کریں',
  reorderTitle: 'سیلز آرڈر دوبارہ کریں',
  reorderFrom: '{{orderNumber}} سے دوبارہ آرڈر',
  placeReorder: 'دوبارہ آرڈر دیں',
  renew: 'تجدید کریں',
  cancel: 'منسوخ کریں',
  generatedOrdersAlert: 'تیار ہونے والے آرڈرز کی تعداد: {{count}}',
  confirmCreateSalesOrderTitle: 'سیلز آرڈر کی تصدیق کریں',
  confirmCreateSalesOrderDescription:
    'سیلز آرڈر بنانے سے پہلے تیار ہونے والے fulfillment آرڈرز کا جائزہ لیں۔',
  generatedOrders: 'تیار شدہ آرڈرز',
  requestedQuantity: 'درخواست کردہ',
  droppedQuantity: 'خارج شدہ',
  dropped: 'خارج',
  droppedOrdersSummary: '{{count}} خارج',
  details: 'تفصیلات',
  downloadPDF: 'PDF ڈاؤن لوڈ کریں',
  viewOrders: 'آرڈرز دیکھیں',
  fillDetails: 'نیچے تفصیلات بھریں',

  // Stats/Status labels
  draft: 'ڈرافٹ',
  active: 'فعال',
  expiring: 'ختم ہونے والا',
  completed: 'مکمل',
  total: 'کل',
  totalValue: 'کل قیمت',
  expiringSoon: 'جلد ختم ہونے والا',
  expires: 'ختم ہوتا ہے',
  value: 'قیمت',
  consumption: 'استعمال',
  used: 'استعمال شدہ',
  orders: 'آرڈرز',

  // Search and filters
  searchPlaceholder: 'سیلز آرڈرز تلاش کریں...',
  noSalesOrders: 'کوئی سیلز آرڈر نہیں',
  noOrdersDescription:
    'آپ نے ابھی تک کوئی سیلز آرڈر نہیں بنایا۔ شروع کرنے کے لیے اپنا پہلا سیلز آرڈر بنائیں۔',
  createFirst: 'اپنا پہلا سیلز آرڈر بنائیں',
  noItemsFound: 'کوئی سیلز آرڈر نہیں ملا',
  noItemsDescription: 'آپ نے ابھی تک کوئی سیلز آرڈر شامل نہیں کیا۔',
  addFirst: 'اپنا پہلا سیلز آرڈر شامل کریں',
  filters: 'فلٹرز',
  filtersTitle: 'سیلز آرڈرز فلٹر کریں',
  filterByStatus: 'حالت کے مطابق فلٹر کریں',
  filterByDeliveryAddress: 'ترسیل کے پتے کے مطابق فلٹر کریں',
  filterByProduct: 'پروڈکٹ کے مطابق فلٹر کریں',
  filterByValue: 'قیمت کے مطابق فلٹر کریں',
  filterByMinValue: 'کم از کم قیمت',
  filterByMaxValue: 'زیادہ سے زیادہ قیمت',
  filterByCreatedDate: 'بنانے کی تاریخ کے مطابق فلٹر کریں',
  filterByValidityDate: 'درستگی کی تاریخ کے مطابق فلٹر کریں',
  filterByAddress: 'پتے کے مطابق فلٹر کریں',
  filterByFactory: 'پلانٹ کے مطابق فلٹر کریں',
  noDeliveryAddresses: 'کوئی ترسیل کے پتے دستیاب نہیں',
  noProductsAvailable: 'کوئی پروڈکٹس دستیاب نہیں',
  noFactoriesAvailable: 'کوئی پلانٹس دستیاب نہیں',
  noFactories: 'کوئی پلانٹس دستیاب نہیں',
  loadingFactories: 'دستیاب پلانٹس لوڈ ہو رہے ہیں...',
  factoryRequired: 'جاری رکھنے کے لیے براہِ کرم پلانٹ منتخب کریں',
  searchFactories: 'پلانٹس تلاش کریں...',
  sorting: 'ترتیب',
  sortBy: 'ترتیب بہ',
  sortOrder: 'ترتیب کا طریقہ',
  searchProducts: 'پروڈکٹس تلاش کریں...',
  searchAddresses: 'پتے تلاش کریں...',
  selectCreatedDateRange: 'بنانے کی تاریخ کی حد منتخب کریں',
  selectValidityDateRange: 'درستگی کی تاریخ کی حد منتخب کریں',

  // Form fields
  basicInfo: 'بنیادی معلومات',
  startDate: 'شروع کی تاریخ',
  endDate: 'اختتام کی تاریخ',
  paymentMethod: 'ادائیگی کا طریقہ',
  city: 'شہر',
  selectCity: 'شہر منتخب کریں',
  searchCity: 'شہر تلاش کریں...',
  noCityFound: 'کوئی شہر نہیں ملا',
  loadingCities: 'دستیاب شہروں کو لوڈ کیا جا رہا ہے...',
  noCitiesForFactory: 'اس پلانٹ کے لیے کوئی ڈیلیوری شہر کنفیگر نہیں',
  cityRequired: 'شہر ضروری ہے',
  selectCityFirst: 'پہلے شہر منتخب کریں',
  deliveryAddress: 'ترسیل کا پتہ',
  selectedAddress: 'منتخب پتہ',
  selectDeliveryAddress: 'ترسیل کا پتہ منتخب کریں',
  deliveryAddressRequired: 'ترسیل کا پتہ ضروری ہے',
  deliveryAddressOptional: 'فی الحال ترسیل کا پتہ اختیاری ہے',
  orderLines: 'آرڈر لائنز',
  productType: 'پروڈکٹ کی قسم',
  splitBy: 'تقسیم بہ',
  deliveryOptions: 'ترسیل کے اختیارات',
  automatic: 'خودکار',
  automaticTooltip: 'سسٹم خود بخود ترسیل کے لیے دستیاب وسائل تفویض کرے گا',
  exworksTooltip: 'کسٹمر پلانٹ سے خود وصول کرے گا',
  assignedResource: 'تفویض شدہ وسیلہ',
  selectResource: 'وسیلہ منتخب کریں',
  assignResource: 'وسیلہ تفویض کریں',
  assignTooltip: 'اس ترسیل کے لیے دستی طور پر ایک مخصوص وسیلہ منتخب کریں',
  spccTooltip: 'بوابة الجنوب اپنے فلیٹ کا استعمال کرتے ہوئے ترسیل کا انتظام کرے گا',
  resourcePlaceholder: 'وسیلہ تلاش اور منتخب کریں...',
  variantUnavailable: 'یہ پروڈکٹ منتخب شدہ پلانٹ میں دستیاب نہیں ہے',
  waitNone: 'ابھی کوئی انتظار نہیں',
  waitMinutes: 'ابھی ~{{minutes}} منٹ انتظار',
  waitHours: 'ابھی ~{{hours}} گھنٹے انتظار',
  waitHoursMinutes: 'ابھی ~{{hours}} گھنٹے {{minutes}} منٹ انتظار',
  waitHint: 'اگر ٹرک ابھی پہنچے تو پلانٹ پر متوقع انتظار',
  bagWeightHint: 'ہر بیگ کا وزن {{weight}} کلو ہے',
  quantityMinPlaceholder: 'کم از کم {{value}}',
  quantityMinHint: 'کم از کم: {{value}}',
  quantityMaxHint: 'زیادہ سے زیادہ: {{value}}',
  orderQuantityLimitsApplied: 'آرڈر حدود: {{min}} - {{max}}',
  orderQuantityMinLimitOnly: 'آرڈر حدود: {{min}}',

  // Order summary
  orderSummary: 'آرڈر کا خلاصہ',
  product: 'پروڈکٹ',
  lineTotal: 'لائن کل',
  assigned: 'تفویض شدہ',
  grandTotal: 'مجموعی کل',
  notes: 'نوٹس',
  notesPlaceholder: 'اس آرڈر کے لیے کوئی اضافی نوٹس شامل کریں...',
  subCustomerLabel: 'ذیلی گاہک',
  subCustomerSelectButton: 'ذیلی گاہک منتخب کریں',
  subCustomerChangeButton: 'تبدیل کریں',
  subCustomerClearButton: 'ہٹائیں',
  subCustomerRequired: 'سیلز آرڈر بنانے کے لیے ذیلی گاہک منتخب کریں',
  createdBy: 'بنانے والا',

  // Credit/Payment
  creditStatus: 'کریڈٹ اسٹیٹس',
  availableCredit: 'دستیاب کریڈٹ',
  orderTotal: 'آرڈر ٹوٹل',
  creditExceededWarning:
    'آرڈر کا کل دستیاب کریڈٹ سے زیادہ ہے۔ براہ کرم آرڈر میں ترمیم کریں یا سپورٹ سے رابطہ کریں۔',
  totalCreditLimit: 'کل کریڈٹ حد',
  vibanNumber: 'VIBAN نمبر',
  vibanInfo: 'پری پیڈ آرڈرز کے لیے اس VIBAN میں رقم منتقل کریں',
  savedCards: 'محفوظ کارڈز',
  addNewCard: 'نیا کارڈ شامل کریں',
  newCard: 'نیا کارڈ',
  useSavedCard: 'محفوظ کارڈ استعمال کریں',
  cardNumber: 'کارڈ نمبر',
  expiry: 'میعاد',
  cvv: 'CVV',
  cardholderName: 'کارڈ ہولڈر کا نام',
  cardholderNamePlaceholder: 'کارڈ پر نام',

  // Detail drawer
  salesOrderDetails: 'سیلز آرڈر کی تفصیلات',
  shipments: 'شپمنٹس',
  noOrdersForContract: 'اس معاہدے کے لیے ابھی تک کوئی آرڈر نہیں',
  noShipmentsForContract: 'اس معاہدے کے لیے ابھی تک کوئی شپمنٹ نہیں',
  multipleFactories: 'متعدد پلانٹس',
  factory: 'پلانٹ',
  noFactoriesForCity: 'اس شہر کے لیے کوئی پلانٹ دستیاب نہیں',

  // Cancel dialog
  cancelConfirmTitle: 'سیلز آرڈر منسوخ کریں',
  cancelConfirmDescription:
    'کیا آپ واقعی سیلز آرڈر {{name}} منسوخ کرنا چاہتے ہیں؟ یہ عمل واپس نہیں ہو سکتا۔',

  // Form section (kept for compatibility)
  form: {
    name: 'سیلز آرڈر کا نام',
    namePlaceholder: 'سیلز آرڈر کا نام درج کریں',
    status: 'حالت',
    validation: {
      nameRequired: 'سیلز آرڈر کا نام ضروری ہے',
    },
  },

  // Status (kept for compatibility)
  status: {
    draft: 'ڈرافٹ',
    active: 'فعال',
    expiring: 'ختم ہونے والا',
    completed: 'مکمل',
    canceled: 'منسوخ',
    inactive: 'غیر فعال',
  },

  // Toast messages
  messages: {
    createSuccess: 'سیلز آرڈر کامیابی سے بنایا گیا',
    updateSuccess: 'سیلز آرڈر کامیابی سے اپ ڈیٹ ہوا',
    deleteSuccess: 'سیلز آرڈر کامیابی سے حذف ہوا',
    deleteConfirm: 'کیا آپ واقعی اس سیلز آرڈر کو حذف کرنا چاہتے ہیں؟',
  },

  // Table headers
  table: {
    name: 'نام',
    status: 'حالت',
    factory: 'پلانٹ',
  },

  // Table column labels
  salesOrder: 'سیلز آرڈر',
  products: 'پروڈکٹس',
  period: 'مدت',
  actions: 'اعمال',
  canceled: 'منسوخ',
  statusLabel: 'حالت',

  // Sort options (additional)
  sortByDate: 'بنانے کی تاریخ',
  sortNewest: 'سب سے نئے پہلے',
  sortOldest: 'سب سے پرانے پہلے',
  sortByOrderNumber: 'آرڈر نمبر',
  sortByOrderNumberAsc: 'آرڈر نمبر (ا-ی)',
  sortByOrderNumberDesc: 'آرڈر نمبر (ی-ا)',
  sortByEndDate: 'اختتام کی تاریخ',
  sortByEndDateAsc: 'اختتام کی تاریخ (قریب ترین)',
  sortByEndDateDesc: 'اختتام کی تاریخ (دور ترین)',
  sortByStartDate: 'شروع کی تاریخ',
  sortByStartDateAsc: 'شروع کی تاریخ (قریب ترین)',
  sortByStartDateDesc: 'شروع کی تاریخ (دور ترین)',
  sortByValue: 'قیمت',
  sortByValueAsc: 'قیمت (کم سے زیادہ)',
  sortByValueDesc: 'قیمت (زیادہ سے کم)',
  sortByConsumption: 'استعمال',
  sortByConsumptionAsc: 'استعمال (کم سے زیادہ)',
  sortByConsumptionDesc: 'استعمال (زیادہ سے کم)',
  sortByRemaining: 'بقایا',
  sortByRemainingAsc: 'بقایا (کم سے زیادہ)',
  sortByRemainingDesc: 'بقایا (زیادہ سے کم)',
  sortByProductCount: 'پروڈکٹس کی تعداد',
  sortByProductCountAsc: 'پروڈکٹس (سب سے کم)',
  sortByProductCountDesc: 'پروڈکٹس (سب سے زیادہ)',
  sortByStatus: 'حالت',
  sortByStatusAsc: 'حالت (ا-ی)',
  sortByStatusDesc: 'حالت (ی-ا)',
  sortByCreatedAt: 'بنانے کی تاریخ',
  sortByOrdersCount: 'آرڈروں کی تعداد',
  sortByOrdersCountAsc: 'آرڈروں کی تعداد (کم سے زیادہ)',
  sortByOrdersCountDesc: 'آرڈروں کی تعداد (زیادہ سے کم)',
  sortOrderDesc: 'نزولی',
  sortOrderAsc: 'صعودی',

  // Payment method labels
  creditLimit: 'کریڈٹ حد',
  creditLimitDesc: 'اپنا دستیاب کریڈٹ استعمال کریں',
  viban: 'VIBAN ٹرانسفر',
  vibanDesc: 'ورچوئل IBAN کے ذریعے ٹرانسفر کریں',
  creditCard: 'کریڈٹ کارڈ',
  creditCardDesc: 'کریڈٹ کارڈ سے ادائیگی کریں',

  // Top-level convenience keys
  name: 'نام',
  namePlaceholder: 'سیلز آرڈر کا نام درج کریں',
  nameRequired: 'سیلز آرڈر کا نام ضروری ہے',
  inactive: 'غیر فعال',
  createSuccess: 'سیلز آرڈر کامیابی سے بنایا گیا',
  updateSuccess: 'سیلز آرڈر کامیابی سے اپ ڈیٹ ہوا',
  deleteSuccess: 'سیلز آرڈر کامیابی سے حذف ہوا',
  deleteConfirm: 'کیا آپ واقعی اس سیلز آرڈر کو حذف کرنا چاہتے ہیں؟',
  minValuePlaceholder: '> 0',
  maxValuePlaceholder: 'کوئی بھی',

  errors: {
    deliveryAddressInvalidRef: 'ڈیلیوری ایڈریس ایک درست مقام حوالہ نہیں ہے',
    deliveryAddressNotFound:
      'ڈیلیوری ایڈریس کسی موجودہ مقام کی طرف اشارہ نہیں کرتا',
    deliveryAddressTenantMismatch:
      'ڈیلیوری ایڈریس آپ کے اکاؤنٹ سے تعلق رکھنا چاہیے',
    deliveryAddressValidationFailed: 'ڈیلیوری ایڈریس کی تصدیق ممکن نہیں',
    cityInvalidRef: 'شہر ایک درست حوالہ نہیں ہے',
    cityRequired: 'شہر ضروری ہے',
    cityNotFound: 'شہر کسی موجودہ شہر کی طرف اشارہ نہیں کرتا',
    cityValidationFailed: 'شہر کی تصدیق ممکن نہیں',
    cityMismatch: 'شہر ڈیلیوری ایڈریس کے شہر سے مطابقت رکھنا چاہیے',
    missingDataPayload: 'درخواست میں ڈیٹا غائب ہے',
    salesOrderLinesRequired: 'کم از کم ایک آرڈر لائن آئٹم ضروری ہے',
    guestFieldsRequired: 'گیسٹ آرڈر کے لیے ای میل اور فون نمبر ضروری ہیں',
    subCustomerRequired: 'اس گاہک کے لیے ذیلی گاہک ضروری ہے',
    salesOrderLinesInvalidFormat: 'آرڈر لائنیں اشیاء کی ایک صف ہونی چاہیے',
    lineCommittedQuantityRequired: 'ہر لائن کے لیے مقررہ مقدار ضروری ہے',
    lineVariantRequired: 'ہر لائن کے لیے مصنوع کی قسم ضروری ہے',
    lineSplitByRequired: 'ہر لائن کے لیے تقسیم کا طریقہ ضروری ہے',
    documentIdRequired: 'دستاویز کی شناخت ضروری ہے',
    notFound: 'سیلز آرڈر نہیں ملا',
  },

  export: {
    exportingTitle: 'برآمد ہو رہا ہے...',
    exportingDesc: 'تمام ریکارڈز حاصل کیے جا رہے ہیں',
    exportFailedTitle: 'برآمد ناکام',
    exportFailed: 'سیلز آرڈرز برآمد نہیں ہو سکے',
    emailPromptTitle: 'ہمیں یہ برآمد کہاں بھیجنی چاہیے؟',
    emailPromptDescription: 'اس برآمد کے لیے ای میل ایڈریس درج کریں۔ چھوٹی فائلیں فوراً ڈاؤن لوڈ ہوں گی، جبکہ بڑی فائلیں ای میل کے ذریعے بھیجی جائیں گی۔',
    emailLabel: 'ای میل ایڈریس',
    emailPlaceholder: 'name@example.com',
    emailRequired: 'ای میل درکار ہے',
    emailInvalid: 'براہ کرم ایک درست ای میل ایڈریس درج کریں',
    exportDownloadedTitle: 'برآمد ڈاؤن لوڈ ہو گئی',
    exportDownloadedDescription: '{{count}} سیلز آرڈرز ڈاؤن لوڈ ہو گئے',
    exportEmailedTitle: 'برآمد ای میل کی جائے گی',
    exportEmailedDescription: 'ہم {{count}} سیلز آرڈرز {{email}} کو بھیجیں گے',
  },
};
